export const PretensionsColumns = [
    {
        name: 'ID',
        key: 'id',
        withHint: true,
    },
    {
        name: 'Номер объекта',
        key: 'client_title',
        withHint: true,
    },
    {
        name: 'Объект',
        key: 'object',
    },
    {
        name: 'Номер накладной заказчика',
        key: 'dop_invoice_number',
        withHint: true,
    },
    {
        name: 'Дата создания',
        key: 'created_at',
        withHint: true,
    },
    {
        name: 'Дата доставки',
        key: 'delivery_date',
        withHint: true,
    },
    {
        name: 'Контрагент',
        key: 'company_name',
        withHint: true,
    },
    {
        name: 'Тип претензии',
        key: 'type_name',
        withHint: true,
    },
    {
        name: 'Сумма',
        key: 'product_amount',
    },
    {
        name: 'Описание товара',
        key: 'product_description',
        withHint: true,
    },
    {
        name: 'Компенсация',
        key: 'compensation_name',
        withHint: true,
    },
    {
        name: 'Подразделение',
        key: 'subdivision_name',
        withHint: true,
    },
    {
        name: 'Конечный файл',
        key: 'final_file',
        withHint: true,
    },
    {
        name: 'Виновная сторона',
        key: 'guilty_side',
    },
    {
        name: 'Статус',
        key: 'status_name',
        withHint: true,
    },
]
